let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6ZyhU"), load("eYX6f")]).then(() => parcelRequire('lNopw'));